document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    let quickAdd = document.querySelectorAll(
      ".product-card__quick-buy-tray__options"
    );

    if (quickAdd) {
      console.log("Quick add variants found");
      quickAdd.forEach((element) => {
        element.addEventListener("click", () => {
          console.log("Quick add variant clicked");
          console.log(
            "Clicked quick add variant id: " +
              element.getAttribute("data-variant-id")
          );
          let formData = {
            items: [
              {
                id: element.getAttribute("data-variant-id"),
                quantity: 1,
              },
            ],
          };

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              document.documentElement.dispatchEvent(
                new CustomEvent("cart:refresh", {
                  bubbles: true,
                })
              );
              document.getElementById("cart-drawer-button").click();
              return response.json();
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        });
      });
    }
    let quickAddTrayCloser = document.querySelectorAll(
      ".product-card__quick-buy-tray__close-button"
    );

    if (quickAddTrayCloser) {
      quickAddTrayCloser.forEach((closeButton) => {
        closeButton.addEventListener("click", () => {
          closeButton.parentElement.classList.add("close");
          closeButton.parentElement.classList.remove("open");
        });
      });
    }
    let quickAddTrayOpener = document.querySelectorAll(
      ".product-card__quick-buy-tray__tray-opener"
    );
    if (quickAddTrayOpener) {
      quickAddTrayOpener.forEach((openButton) => {
        openButton.addEventListener("click", () => {
          openButton.parentElement.parentElement.parentElement.parentElement
            .querySelector(".product-card__quick-buy-tray")
            .classList.add("open");
          openButton.parentElement.parentElement.parentElement.parentElement
            .querySelector(".product-card__quick-buy-tray")
            .classList.remove("close");
        });
      });
    }
  }, 1000);
  let productImages = document.querySelectorAll(".product-gallery__media");
  let savedIndex = -1; // Initialize savedIndex to an invalid value

  if (productImages) {
    productImages.forEach((element, initialIndex) => {
      // Add a click event listener to each product image
      element.addEventListener("click", () => {
        savedIndex = initialIndex; // Set the savedIndex to the index of the clicked product image

        setTimeout(() => {
          let pswpContainer = document.querySelector(".pswp");
          // Create a new div with the class 'pswp_thumbnail'
          let pswpThumbnailDiv = document.createElement("div");
          pswpThumbnailDiv.classList.add("pswp_thumbnail");

          // Loop through productImages and add them to the pswp_thumbnail div
          productImages.forEach((imgElement) => {
            let img =
              imgElement.tagName === "IMG"
                ? imgElement.cloneNode(true)
                : document.createElement("img");

            if (imgElement.tagName !== "IMG") {
              img.src =
                imgElement.src || imgElement.querySelector("img")?.src || "";
            }

            // Add click event to the thumbnail images
            img.addEventListener("click", () => {
              let clickedIndex = Array.from(pswpThumbnailDiv.children).indexOf(
                img
              );
              let indexDifference = clickedIndex - savedIndex;

              // Navigate based on index difference
              if (indexDifference > 0) {
                for (let i = 0; i < Math.abs(indexDifference); i++) {
                  document.querySelector(".pswp__button:nth-child(3)").click(); // Next button
                }
              } else if (indexDifference < 0) {
                for (let i = 0; i < Math.abs(indexDifference); i++) {
                  document.querySelector(".pswp__button:nth-child(1)").click(); // Previous button
                }
              }

              // Update savedIndex with the clickedIndex
              savedIndex = clickedIndex;
            });

            // Append the image to the pswp_thumbnail div
            pswpThumbnailDiv.appendChild(img);
          });

          // Clear existing pswp_thumbnail if it already exists
          let existingThumbnail =
            pswpContainer.querySelector(".pswp_thumbnail");
          if (existingThumbnail) {
            existingThumbnail.remove();
          }

          // Append the pswp_thumbnail div to the pswp container
          pswpContainer.appendChild(pswpThumbnailDiv);

          // // Adjust thumbnail element width
          setTimeout(() => {
            let pswpImg = Array.from(
              pswpContainer.querySelectorAll(".pswp__img")
            ).find(
              (img) =>
                img.classList.length === 1 &&
                img.classList.contains("pswp__img")
            );
            if (pswpImg) {
              // Retrieve the attribute value and ensure it's a number
              let largestUsedSize = pswpImg.getAttribute(
                "data-largest-used-size"
              );

              console.log(largestUsedSize);

              // Calculate the new width
              let newWidth = Number(largestUsedSize) + 200 + "px";

              // Apply the new width to the pswp_thumbnail div
              pswpThumbnailDiv.style.width = newWidth;
            }
            pswpThumbnailDiv.style.display = "flex";
          }, 400);

          // Track clicks on next and previous buttons
          let prevButton = document.querySelector(".pswp__button:nth-child(1)");
          let closeButton = document.querySelector(
            ".pswp__button:nth-child(2)"
          );
          let nextButton = document.querySelector(".pswp__button:nth-child(3)");

          if (prevButton && nextButton) {
            prevButton.addEventListener("click", () => {
              if (savedIndex > 0) {
                savedIndex -= 1; // Decrease index for previous button
              }
            });
            closeButton.addEventListener("click", () => {
              pswpThumbnailDiv.style.display = "none";
            });

            nextButton.addEventListener("click", () => {
              if (savedIndex < productImages.length - 1) {
                savedIndex += 1; // Increase index for next button
              }
            });
          }
        }, 100);
      });
    });
  }

  let relatedButton = document.getElementById("first_button");
  let recentlyButton = document.getElementById("second_button");

  if (relatedButton) {
    relatedButton.addEventListener("click", () => {
      relatedButton.classList.add("active");
      recentlyButton.classList.remove("active");
      document.getElementById("related-products").classList.add("active");
      document.getElementById("recently-viewed").classList.remove("active");
    });
  }
  if (recentlyButton) {
    recentlyButton.addEventListener("click", () => {
      relatedButton.classList.remove("active");
      recentlyButton.classList.add("active");
      document.getElementById("related-products").classList.remove("active");
      document.getElementById("recently-viewed").classList.add("active");
    });
  }
});
